import { UiSchema } from "@rjsf/utils/lib/types";

export const anamnesisUiSchema = (t: (s: string) => string): UiSchema => {
  return {
    "ui:order": [
      "p_start",
      "contact_id",
      "info_id",
      "intro",
      "original",
      "cpap",
      "osas_des",
      "p_contact",
      "p_breathing",
      "p_therapies",
      "p_suffer",
      "p_alertness",
      "p_end",
      "ess_new",
      "ess_initial",
      "ess_diff"
    ],
    p_start: {
      "ui:field": "HtmlDescriptionField",
    },
    contact_id: {
      "ui:widget": "hidden",
    },
    info_id: {
      "ui:widget": "hidden",
    },
    intro: {
      "ui:widget": "hidden",
    },
    original: {
      "ui:widget": "hidden",
    },
    cpap: {
      "ui:widget": "hidden",
    },
    osas_des: {
      "ui:widget": "hidden",
    },
    p_contact: {
      "ui:order": ["state_referred_by_doctor", "fs_alert_velumount", "fs_referred_physician"],
      state_referred_by_doctor: {
        "ui:widget": "hidden",
      },
      fs_alert_velumount: {
        alert_velumount: {
          "ui:widget": "checkboxes",
          "ui:options": {
            classNames: "vertical-aligned-items intend_subgroup_alert_velumount",
          },
          "ui:enumNames": [
            t("survey.anamnese.p_contact.fs_alert_velumount.alert_velumount_recommended"),
            // t("survey.anamnese.p_contact.fs_alert_velumount.alert_velumount_intent_internet"),
            t("survey.anamnese.p_contact.fs_alert_velumount.alert_velumount_intent_social_media"),
            t("survey.anamnese.p_contact.fs_alert_velumount.alert_velumount_intent_search_engines"),
            t("survey.anamnese.p_contact.fs_alert_velumount.alert_velumount_intent_tv_np"),
            // t("survey.anamnese.p_contact.fs_alert_velumount.alert_velumount_intent_tv_np_puls_20190513"),
            // t("survey.anamnese.p_contact.fs_alert_velumount.alert_velumount_intent_tv_np_reporter"),
            // t("survey.anamnese.p_contact.fs_alert_velumount.alert_velumount_intent_tv_np_radio"),
            // t("survey.anamnese.p_contact.fs_alert_velumount.alert_velumount_intent_tv_np_20min"),
            // t("survey.anamnese.p_contact.fs_alert_velumount.alert_velumount_intent_tv_np_bund_bz"),
            // t("survey.anamnese.p_contact.fs_alert_velumount.alert_velumount_intent_tv_np_extra_20190512"),
            t("survey.anamnese.p_contact.fs_alert_velumount.alert_velumount_by_doctor"),
            t("survey.anamnese.p_contact.fs_alert_velumount.alert_velumount_by_physio"),
            t("survey.anamnese.p_contact.fs_alert_velumount.alert_velumount_by_traditional"),
            t("survey.anamnese.p_contact.fs_alert_velumount.alert_velumount_other"),
          ],
        },
      },
      fs_referred_physician: {
        "ui:order": ["referred_physician", "referred_physician_place", "referred"],
        referred: {
          "ui:widget": "radio",
          "ui:enumNames": [
            t("survey.anamnese.p_contact.fs_referred_physician.referred.is_referred_no"),
            t("survey.anamnese.p_contact.fs_referred_physician.referred.is_referred_yes"),
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },
    },
    p_breathing: {
      "ui:order": ["state_osas_diagnosis", "fs_osas_sleep", "fs_osas_diagnosis", "fs_ent_visit"],
      state_osas_diagnosis: {
        "ui:widget": "hidden",
      },
      fs_osas_sleep: {
        "ui:order": ["fs_osas_sleep_title", "osas", "osas_source"],
        fs_osas_sleep_title: {
          "ui:field": "HtmlTitleField",
        },
        osas: {
          "ui:widget": "radio",
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
          "ui:enumNames": [
            t("survey.anamnese.p_breathing.fs_osas_sleep.osas.osas_no"),
            t("survey.anamnese.p_breathing.fs_osas_sleep.osas.osas_assumed"),
            t("survey.anamnese.p_breathing.fs_osas_sleep.osas.osas_yes"),
          ],
        },
        osas_source: {
          "ui:widget": "checkboxes",
          "ui:enumNames": [
            t("survey.anamnese.p_breathing.fs_osas_sleep.osas_source.osas_observed"),
            t("survey.anamnese.p_breathing.fs_osas_sleep.osas_source.osas_self"),
            t("survey.anamnese.p_breathing.fs_osas_sleep.osas_source.osas_diagnosis"),
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },
      fs_osas_diagnosis: {
        "ui:order": [
          "fs_osas_diagnosis_title",
          "osas_physician",
          "osas_physician_place",
          "osas_specialization",
          "osas_other_medical_section",
          "osas_ahi_year",
          "osas_ahi",
          "osas_sleeplab",
          "osas_report",
        ],
        fs_osas_diagnosis_title: {
          "ui:field": "HtmlTitleField",
        },
        osas_ahi_year: {
          "ui:widget": "updown",
          "ui:options": {
            inputType: "number",
            min: 1980,
            max: new Date().getFullYear(),
            classNames: "input-max-width-100",
          },
        },
        osas_ahi: {
          "ui:widget": "updown",
          "ui:options": {
            inputType: "number",
            min: 0,
            max: 1000,
            classNames: "input-max-width-100",
          },
        },
        osas_specialization: {
          "ui:widget": "radio",
          "ui:enumNames": [
            t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_specialization.ent_specialist"),
            t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_specialization.pulmonologist"),
            t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_specialization.general_practitioner"),
            t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_specialization.other"),
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
        osas_sleeplab: {
          "ui:widget": "radio",
          "ui:enumNames": [
            t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_sleeplab.easy"),
            t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_sleeplab.medium"),
            t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_sleeplab.serious"),
            t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_sleeplab.unknown"),
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
        osas_report: {
          "ui:widget": "radio",
          "ui:enumNames": [
            t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_report.no"),
            t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_report.yes"),
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },
      fs_ent_visit: {
        "ui:order": ["fs_ent_visit_title", "hno_year"],
        fs_ent_visit_title: {
          "ui:field": "HtmlTitleField",
        },
        hno_year: {
          "ui:widget": "updown",
          "ui:options": {
            inputType: "number",
            min: 1980,
            max: new Date().getFullYear(),
            classNames: "input-max-width-100",
          },
        },
      },
    },
    p_therapies: {
      "ui:order": ["state_applied_cpap_therapy", "fs_therapies", "fs_cpap_using_1"],
      state_applied_cpap_therapy: {
        "ui:widget": "hidden",
      },
      fs_therapies: {
        "ui:order": [
          "fs_therapies_title",
          "recommended_therapies",
          "other_recom_therapies",
          "operation",
          "operation_where",
          "applied_therapies",
          "other_therapies",
          "fscpapusing1",
        ],
        fs_therapies_title: {
          "ui:field": "HtmlTitleField",
        },
        recommended_therapies: {
          "ui:widget": "checkboxes",
          "ui:enumNames": [
            t("survey.anamnese.p_therapies.fs_therapies.recommended_therapies.none"),
            t("survey.anamnese.p_therapies.fs_therapies.recommended_therapies.CPAP"),
            t("survey.anamnese.p_therapies.fs_therapies.recommended_therapies.Operation"),
            t("survey.anamnese.p_therapies.fs_therapies.recommended_therapies.Protrusion"),
            t("survey.anamnese.p_therapies.fs_therapies.recommended_therapies.Nosetape"),
            t("survey.anamnese.p_therapies.fs_therapies.recommended_therapies.Spirotiger"),
            t("survey.anamnese.p_therapies.fs_therapies.recommended_therapies.Velumount"),
            t("survey.anamnese.p_therapies.fs_therapies.recommended_therapies.other"),
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },

        operation: {
          "ui:widget": "radio",
          "ui:enumNames": [
            t("survey.anamnese.p_therapies.fs_therapies.operation.no"),
            t("survey.anamnese.p_therapies.fs_therapies.operation.yes"),
          ],
        },

        operation_where: {
          "ui:widget": "checkboxes",
          "ui:enumNames": [
            t("survey.anamnese.p_therapies.fs_therapies.operation_where.tonsils"),
            t("survey.anamnese.p_therapies.fs_therapies.operation_where.mocous_membranes"),
            t("survey.anamnese.p_therapies.fs_therapies.operation_where.tooth_position"),
            t("survey.anamnese.p_therapies.fs_therapies.operation_where.tongue"),
            t("survey.anamnese.p_therapies.fs_therapies.operation_where.palate"),
            t("survey.anamnese.p_therapies.fs_therapies.operation_where.nose"),
          ],
        },

        applied_therapies: {
          "ui:widget": "checkboxes",
          "ui:enumNames": [
            t("survey.anamnese.p_therapies.fs_therapies.applied_therapies.none"),
            t("survey.anamnese.p_therapies.fs_therapies.applied_therapies.CPAP"),
            t("survey.anamnese.p_therapies.fs_therapies.applied_therapies.Protrusion"),
            t("survey.anamnese.p_therapies.fs_therapies.applied_therapies.Nosetape"),
            t("survey.anamnese.p_therapies.fs_therapies.applied_therapies.Spirotiger"),
            t("survey.anamnese.p_therapies.fs_therapies.applied_therapies.other"),
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },

      fs_cpap_using_1: {
        "ui:order": ["fs_cpap_using_1_title", "cpap_using_current_1"],
        fs_cpap_using_1_title: {
          "ui:field": "HtmlTitleField",
        },
        cpap_using_current_1: {
          "ui:widget": "radio",
          "ui:enumNames": [
            t("survey.anamnese.p_therapies.fs_cpap_using_1.cpap_using_current_1.always (6-7 times per week)"),
            t("survey.anamnese.p_therapies.fs_cpap_using_1.cpap_using_current_1.often (ca. 2-5 times per week)"),
            t("survey.anamnese.p_therapies.fs_cpap_using_1.cpap_using_current_1.rarly (less than 2 times per week)"),
            t("survey.anamnese.p_therapies.fs_cpap_using_1.cpap_using_current_1.never, but i keep the cpap at home"),
            t("survey.anamnese.p_therapies.fs_cpap_using_1.cpap_using_current_1.never, i retourned the cpap"),
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },
    },

    p_suffer: {
      "ui:order": ["fs_suffer", "fs_symptomens", "fs_medication", "fs_epilepsy"],
      fs_suffer: {
        "ui:order": ["fs_suffer_title", "assess_suffer_1", "suffer_person_concerned_1"],
        fs_suffer_title: {
          "ui:field": "HtmlTitleField",
        },
        assess_suffer_1: {
          "ui:field": "MatrixField",
          "ui:options": {
            columns: [
              {
                value: "well bearable",
                label: t("survey.custom.assess_suffer.columns.well bearable"),
              },
              {
                value: "rather well bearable",
                label: t("survey.custom.assess_suffer.columns.rather well bearable"),
              },
              { value: "medium", label: t("survey.custom.assess_suffer.columns.medium") },
              {
                value: "rather unbearable",
                label: t("survey.custom.assess_suffer.columns.rather unbearable"),
              },
              { value: "unbearable", label: t("survey.custom.assess_suffer.columns.unbearable") },
            ],
            rows: [
              {
                value: "self_assess_suffer_1",
                label: "",
              },
            ],
          },
        },
        suffer_person_concerned_1: {
          "ui:field": "MatrixField",
          "ui:options": {
            columns: [
              {
                value: "well bearable",
                label: t("survey.custom.assess_suffer.columns.well bearable"),
              },
              {
                value: "rather well bearable",
                label: t("survey.custom.assess_suffer.columns.rather well bearable"),
              },
              { value: "medium", label: t("survey.custom.assess_suffer.columns.medium") },
              {
                value: "rather unbearable",
                label: t("survey.custom.assess_suffer.columns.rather unbearable"),
              },
              { value: "unbearable", label: t("survey.custom.assess_suffer.columns.unbearable") },
            ],
            rows: [
              {
                value: "suffer_person_concerned_1",
                label: "",
              },
            ],
          },
        },
      },
      fs_symptomens: {
        "ui:order": ["fs_symptomens_title", "symptoms"],
        fs_symptomens_title: {
          "ui:field": "HtmlTitleField",
        },
        symptoms: {
          "ui:widget": "checkboxes",
          "ui:enumNames": [
            t("survey.anamnese.p_suffer.fs_symptomens.symptoms.none"),
            t("survey.anamnese.p_suffer.fs_symptomens.symptoms.Tagesmüdigkeit"),
            t("survey.anamnese.p_suffer.fs_symptomens.symptoms.Einschlafneigung tagsüber"),
            t("survey.anamnese.p_suffer.fs_symptomens.symptoms.Konzentrationsprobleme"),
            t("survey.anamnese.p_suffer.fs_symptomens.symptoms.Erhöhter Blutdruck"),
            t("survey.anamnese.p_suffer.fs_symptomens.symptoms.Morgendliche Kopfschmerzen"),
            t("survey.anamnese.p_suffer.fs_symptomens.symptoms.Nächtliches Schwitzen"),
            t("survey.anamnese.p_suffer.fs_symptomens.symptoms.Bruxismus (Zähneknirschen)"),
            t("survey.anamnese.p_suffer.fs_symptomens.symptoms.Reflux (saures Aufstossen)"),
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },
      fs_medication: {
        "ui:order": ["fs_medication_title", "medication"],
        fs_medication_title: {
          "ui:field": "HtmlTitleField",
        },
        medication: {
          "ui:widget": "checkboxes",
          "ui:enumNames": [
            t("survey.anamnese.p_suffer.fs_medication.medication.none"),
            t("survey.anamnese.p_suffer.fs_medication.medication.blood_thinner"),
            t("survey.anamnese.p_suffer.fs_medication.medication.blood_lower"),
            t("survey.anamnese.p_suffer.fs_medication.medication.psychopharmaka"),
            t("survey.anamnese.p_suffer.fs_medication.medication.hypnotic"),
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },

      fs_epilepsy: {
        "ui:order": ["fs_epilepsy_title", "epilepsy", "epilepsy_last_occurance"],
        fs_epilepsy_title: {
          "ui:field": "HtmlTitleField",
        },
        epilepsy: {
          "ui:widget": "radio",
          "ui:enumNames": [t("survey.anamnese.p_suffer.fs_epilepsy.epilepsy.no"), t("survey.anamnese.p_suffer.fs_epilepsy.epilepsy.yes")],
        },
      },
    },
    p_alertness: {
      "ui:order": ["fs_fall_asleep_1", "fs_relaxed_1", "fs_comment"],
      fs_fall_asleep_1: {
        "ui:order": ["epworth_title", "epworth_description", "epworth"],
        title: "",
        epworth_title: {
          "ui:field": "HtmlTitleField",
        },
        epworth_description: {
          "ui:field": "HtmlDescriptionField",
        },
        epworth: {
          epworth: {
            "ui:field": "MatrixField",
            "ui:options": {
              columns: [
                { value: "0", label: t("survey.custom.epworth.columns.niemals_einschlafen") },
                { value: "1", label: t("survey.custom.epworth.columns.kaum_einschlafen") },
                { value: "2", label: t("survey.custom.epworth.columns.moeglicherweise_einschlafen") },
                { value: "3", label: t("survey.custom.epworth.columns.wahrscheinlich_einschlafen") },
              ],
              rows: [
                { value: "epworth_Sitting and readin", label: t("survey.custom.epworth.rows.Sitting and readin") },
                { value: "epworth_Watching TV", label: t("survey.custom.epworth.rows.Watching TV") },
                {
                  value: "epworth_Sitting, inactive in a public place",
                  label: t("survey.custom.epworth.rows.Sitting, inactive in a public place"),
                },
                {
                  value: "epworth_As a passenger in a car for an hour without break",
                  label: t("survey.custom.epworth.rows.As a passenger in a car for an hour without break"),
                },
                {
                  value: "epworth_Lying down to rest in the afternoon",
                  label: t("survey.custom.epworth.rows.Lying down to rest in the afternoon"),
                },
                { value: "epworth_Sitting an talking to someone", label: t("survey.custom.epworth.rows.Sitting an talking to someone") },
                {
                  value: "epworth_Sitting quietly after lunch without alcohol",
                  label: t("survey.custom.epworth.rows.Sitting quietly after lunch without alcohol"),
                },
                {
                  value: "In a car while stopped for a few minutes in the traffic",
                  label: t("survey.custom.epworth.rows.In a car while stopped for a few minutes in the traffic"),
                },
              ],
            },
          },
        },
      },

      fs_relaxed_1: {
        fs_relaxed_1_title: {
          "ui:field": "HtmlTitleField",
        },
        relaxed_1: {
          "ui:widget": "radio",
          "ui:enumNames": [
            t("survey.anamnese.p_alertness.fs_relaxed_1.relaxed_1.almost always"),
            t("survey.anamnese.p_alertness.fs_relaxed_1.relaxed_1.often"),
            t("survey.anamnese.p_alertness.fs_relaxed_1.relaxed_1.sometimes"),
            t("survey.anamnese.p_alertness.fs_relaxed_1.relaxed_1.rare"),
            t("survey.anamnese.p_alertness.fs_relaxed_1.relaxed_1.never"),
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },
      fs_comment: {
        "ui:order": ["fs_comment_title", "comment"],
        fs_comment_title: {
          "ui:field": "HtmlTitleField",
        },
        comment: {
          "ui:widget": "textarea",
          "ui:options": {
            rows: 5,
          },
        },
      },
    },

    p_end: {
      "ui:order": ["fs_additional_data", "goodbye"],
      fs_additional_data: {
        "ui:order": ["fs_additional_data_title", "weight", "size"],
        fs_additional_data_title: {
          "ui:field": "HtmlTitleField",
        },
        weight: {
          "ui:widget": "updown",
          "ui:options": {
            inputType: "number",
            min: 20,
            max: 200,
            classNames: "input-max-width-100",
          },
        },
        size: {
          "ui:widget": "updown",
          "ui:options": {
            inputType: "number",
            min: 70,
            max: 250,
            classNames: "input-max-width-100",
          },
        },
      },

      goodbye: {
        "ui:field": "HtmlDescriptionField",
      },
    },

    // final: {
    ess_initial: {
      "ui:widget": "hidden",
    },
    ess_new: {
      "ui:widget": "hidden",
    },
    ess_diff: {
      "ui:widget": "hidden",
    },
  };
};
